import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, Input, NgModule, signal } from '@angular/core'
import { WorkflowManagerApiService } from '../../../../_services'


import { FuseqRaidenService } from '../../../../FuseQ/fuseq-raiden/fuseqRaiden.service'
import { TreeNode, MessageService } from '@openng/optimus-ui/api'
import { CommonModule } from '@angular/common'
import { ButtonModule } from '@openng/optimus-ui/button'
import { TableModule } from '@openng/optimus-ui/table'
import { TreeTableModule } from '@openng/optimus-ui/treetable'
import { AccordionModule } from '@openng/optimus-ui/accordion'
import { ChipModule } from '@openng/optimus-ui/chip'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'

import { OptimUiSharedModule } from '../../../../shared/optimus-ui-shared.module';
import { FqDialogNavComponent } from '../../../../shared/fq-dialog-nav.component';
@Component({
  selector: 'speed-test',
  templateUrl: 'speedtest.html',
  styleUrls: ['./speedtest.scss'],
  imports: [OptimUiSharedModule, CommonModule, TableModule, TreeTableModule, ButtonModule, AccordionModule, ChipModule, FontAwesomeModule, FqDialogNavComponent]
})

export class SpeedTestComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() set fraz (value: string | null) {
    // this.record = value
    if (value) {
      this.showHistory(value)
    }
  }

  constructor (
    private readonly messageService: MessageService,
    private readonly fuseqRaiden: FuseqRaidenService,
    private readonly workflowApiService: WorkflowManagerApiService
  ) {

  }

  filters: any = {
    searchText: ''
  }

  tunnelModalVisible = false

  // selected = -1;
  ngOnDestroy (): void {
    // this.subscribed.unsubscribe()
  }

  ngAfterViewInit (): void {
  }

  ngOnInit (): void {

  }

  displaySideSpeed = false
  valuefilterSpeed = ''
  headerSidebar = ''
  historySpeedtest = signal<any[]>([])
  frazexport = null
  tunnelget = []
  tunnelTab = '0'
  get tunnelSections () {
    return this.tunnelget.map((_, i) => ({ key: String(i), label: 'CiscoEdge ' + (i + 1), icon: ['fas', 'circle'] }))
  }
  loadingTunnel = false

  showHistory (fraz) {
    this.historySpeedtest.set([])
    this.frazexport = fraz// Description.substring(0, record.Description.indexOf(' -'))
    this.getHistory(this.frazexport)
    this.headerSidebar = 'SpeedTest Frazionario ' + this.frazexport
    this.displaySideSpeed = true
  }

  getHistory (frazionario) {
    this.workflowApiService.GetSpeedTestHistoryCisco(frazionario).subscribe(data => {
      this.historySpeedtest.set(data)
      /* this.historySpeedtest.forEach(x => {
        if (x.Avg_RTT != null) {
          x.Avg_RTT = x.Avg_RTT.replace(' ms', '')
        }
      }) */
    }, error => {
      console.log(error)
    })
  }

  headerDetailSpeedTest = ''
  result = []
  tunnel = ''
  valuefilterdetail = ''
  showDetailsSpeed (speed) {
    this.tunnelget = []
    this.tunnelTab = '0'
    this.tunnelget = speed.SpeedTest.tunnels
    console.log(this.tunnelget)
    this.treeTableData()
    this.tunnelModalVisible = true
  }

  treeTableData () {
    this.tunnelget.forEach((x: any) => {
      const tree: TreeNode[] = []
      x.circuits.forEach(y => {
        const circuito = {
          data: {
            name: y.color,
            health: y['circuit-health']
          },
          children: []
        }
        y.tunnels.forEach(t => {
          const tunnel = {
            data: t
          }
          circuito.children.push(tunnel)
        })
        tree.push(circuito)
      })
      x.tree = tree
    })
  }

  hideAddModal () {
    this.loadingTunnel = false
    this.tunnelget = []
    this.tunnelModalVisible = false
  }
}
@NgModule({
  imports: [OptimUiSharedModule, CommonModule, TableModule, TreeTableModule, ButtonModule, AccordionModule, ChipModule, FontAwesomeModule, FqDialogNavComponent, SpeedTestComponent],
  exports: [SpeedTestComponent]
})
export class speedTestModule { }
